import type { FormControlSetting, Setting } from '@/app/editor/iframe/atom/Atom.model';
import { GpElement } from '@/app/editor/iframe/atom/element/GpElement';
import GpCheckboxInfo from '@/app/editor/sidebar/elementsInfo/checkbox';

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'html:attr',
    name: 'name',
    targetSelector: '.gf_checkbox',
    property: 'name',
  },
  {
    type: 'html:attr',
    name: 'description',
    targetSelector: '.gf_checkbox',
    property: 'name',
  },
  {
    type: 'html:attr',
    name: 'required',
    targetSelector: '.gf_checkbox',
    property: 'required',
  },
  {
    type: 'html:attr',
    name: 'selected',
    targetSelector: '.gf_checkbox',
    default_value: '0',
    property: 'checked',
  },
  {
    type: 'css',
    name: 'font-size',
    targetSelector: '.elm span',
    property: 'font-size',
    require: true,
  },
  {
    type: 'css',
    name: 'line-height',
    targetSelector: '.elm span',
    property: 'line-height',
    unit: 'em',
    require: true,
  },
  {
    type: 'css',
    name: 'letter-spacing',
    targetSelector: '.elm span',
    property: 'letter-spacing',
    require: true,
  },
  {
    type: 'css',
    name: 'color',
    fieldType: 'color',
    targetSelector: '.elm span',
    property: 'color',
    require: true,
  },
  {
    type: 'css',
    name: 'font',
    targetSelector: '.elm span',
    property: 'font-family',
    require: true,
  },
  {
    type: 'css',
    name: 'padding',
    targetSelector: '.elm span',
    property: 'padding-left',
    require: true,
  },
  {
    type: 'css',
    name: 'position',
    targetSelector: '.gf_checkbox',
    property: 'top',
    require: true,
  },
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.elm',
    property: 'align',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.elm',
    property: 'data-exc',
  },
];
/**
 * Button Atom Element
 */
export class GpCheckbox extends GpElement {
  public $el: JQuery;

  /**
   * [Hook] [override]
   * @param settings ()
   * @returns settings data
   */
  formatSettingAtom(settings: Array<Setting>): Array<Setting> {
    return settings.length > 0 ? settings : GpCheckboxInfo.settings;
  }

  /**
   * [Hook] [override]
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || GpCheckboxInfo.name;
  }

  /**
   * [Hook] [override]
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || GpCheckboxInfo.slug;
  }

  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
  /**
   * getClassName
   * @returns selector with Class name of element
   */
  getTargetClassSelector(): string {
    return '.' + GpCheckboxInfo.class;
  }
}
